import { isDefined, isNotDefined } from '../utils/lang';
var global = {};
export function getGlobal(key) {
    return isDefined(global[key])
        ? global[key]
        : window[key];
}
export function getAllGlobals() {
    return global;
}
export function hasGlobal(key) {
    return isDefined(getGlobal(key));
}
export function setGlobalIfNone(key, val) {
    if (isNotDefined(window[key])) {
        global[key] = val;
        window[key] = val;
    }
    else {
        console.info("Global var [" + key + "] exists.");
    }
}
export function setGlobal(key, val) {
    global[key] = val;
    window[key] = val;
}
export function delGlobal(key) {
    if (hasGlobal(key)) {
        if (isDefined(global[key]))
            delete global[key];
        if (isDefined(window[key]))
            delete window[key];
    }
    else {
        console.info("Nothing deleted from global.");
    }
}
